<script>
import baseMixin from '@/mixins/baseMixin'
import { LayoutToggle } from '@/shared/constants/layout/LayoutToggle.js'

export default {
  name: 'LayoutFilter',
  mixins: [baseMixin],
  props: {
    preSelect: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      layoutToggle: 0,
    }
  },
  computed: {
    defaultLayoutOptions() {
      return [
        {
          id: 'tile-view-toggle',
          icon: 'mdi-view-grid',
          tooltip: 'Cards',
          emit: LayoutToggle.TILE,
        },
        {
          id: 'list-view-toggle',
          icon: 'mdi-format-list-bulleted',
          tooltip: 'List',
          emit: LayoutToggle.LIST,
        },
      ]
    },
  },
  mounted() {
    this.layoutToggle = this.preSelect
  },
  methods: {
    layoutChanged(type) {
      this.$emit('layoutChanged', type)
    },
  },
}
</script>

<template>
  <v-btn-toggle v-model="layoutToggle" group dense color="primary" mandatory>
    <v-tooltip
      v-for="option of !options ? defaultLayoutOptions : options"
      :key="option.id"
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :id="option.id"
          class="rounded"
          v-bind="attrs"
          @click="layoutChanged(option.emit)"
          v-on="on"
        >
          <v-icon small>{{ option.icon }}</v-icon>
        </v-btn>
      </template>
      <span v-text="option.tooltip"></span>
    </v-tooltip>
  </v-btn-toggle>
</template>
